import { render, staticRenderFns } from "./ProductFlag.vue?vue&type=template&id=0426e91c"
var script = {}
import style0 from "./ProductFlag.vue?vue&type=style&index=0&id=0426e91c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports